import { Alert, Stack, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { Button } from 'src/components';
import { AuthCard } from 'src/auth/components/AuthCard';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

interface SsoOnlyMessageProps {
  variant: 'recovery' | 'platform';
  onBackToLogin: () => void;
}

export const SsoOnlyMessage = ({ variant, onBackToLogin }: SsoOnlyMessageProps) => {
  const isRecovery = variant === 'recovery';

  return (
    <AuthCard>
      <Stack gap="md" align="center">
        <Text fz="xl" fw={FONT_WEIGHTS.semibold} ta="center">
          {isRecovery ? 'Password Reset Unavailable' : 'Credentials Managed by SSO'}
        </Text>

        <Alert icon={<IconInfoCircle size={16} />} color="blue" variant="light">
          Your organization uses single sign-on (SSO) for authentication.{' '}
          {isRecovery
            ? 'Password reset is not available.'
            : 'Credential management is handled by your identity provider.'}{' '}
          Please contact your administrator if you need help accessing your account.
        </Alert>

        <Button onClick={onBackToLogin} fullWidth variant="primary">
          Back to Login
        </Button>
      </Stack>
    </AuthCard>
  );
};
